import '../../../../1_templates_new/elements/js/product-view';

$(document).ready(() => $('.product_info_size_item.guide').remove())